module.exports = __webpack_public_path__ + "img/15_60.ea18be83.png";